const ALLOWED_TYPES = ["slack", "sms", "call"];

export const getDefaultAlertPreferences = user => {
    if (!user || !Array.isArray(user.alertPreferences)) {
        return [];
    }
    return user.alertPreferences;
};

export const normalizeOverrides = overrides => {
    if (!Array.isArray(overrides)) {
        return [];
    }
    return overrides.map(item => ({
        type: item?.type || "email",
        offset: Number(item?.offset || 0),
    }));
};

export const validateOverrides = overrides => {
    const errors = [];
    const seen = new Set();

    overrides.forEach((row, index) => {
        const rowErrors = {};
        const offset = Number(row.offset);
        if (!Number.isInteger(offset) || offset <= 0) {
            rowErrors.offset = "Enter a positive whole number.";
        }
        if (!ALLOWED_TYPES.includes(row.type)) {
            rowErrors.type = "Select a valid channel.";
        }

        const key = `${row.type}-${offset}`;
        if (seen.has(key)) {
            rowErrors.duplicate = "Duplicate reminder.";
        }
        seen.add(key);

        errors[index] = rowErrors;
    });

    if (overrides.length > 5) {
        errors.list = "You can add up to 5 reminders.";
    }

    return errors;
};

export const hasValidationErrors = errors => {
    if (!errors || errors.length === 0) {
        return false;
    }
    if (errors.list) {
        return true;
    }
    return errors.some(row => row && Object.keys(row).length > 0);
};

export const getChannelWarning = (type, user) => {
    if (type === "slack" && !user?.slackWebhookUrl) {
        return "Connect Slack to use this channel.";
    }
    if (type === "sms" && !(user?.phoneNumber && user?.countryCode)) {
        return "Add a phone number to use SMS.";
    }
    if (type === "call" && !(user?.phoneNumber && user?.countryCode)) {
        return "Add a phone number to use Call.";
    }
    return "";
};

export const computeReminderPreview = ({ startTimestamp, overrides }) => {
    if (!startTimestamp || !Array.isArray(overrides)) {
        return [];
    }
    return overrides
        .filter(item => Number(item.offset) > 0)
        .map(item => ({
            type: item.type,
            offset: Number(item.offset),
        }));
};
